export default __webpack_public_path__ + "158d9bb6eb0110e7f87c9a620ccfff16.png";